import MovieCard from "@/components/feature/MovieCard";
import { movies } from "@/mocks/movies";

export default function FeaturedMovies() {
  const featured = [...movies].sort((a, b) => b.hotness - a.hotness).slice(0, 8);

  if (featured.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-background-300 py-12 text-center text-sm text-foreground-500">
        暂无相关影视资讯，敬请期待
      </div>
    );
  }

  return (
    <div data-product-shop className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
      {featured.map((movie) => (
        <MovieCard key={movie.id} movie={movie} />
      ))}
    </div>
  );
}